import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge classnames with Tailwind conflict resolution.
 * Same helper as apps/web/src/lib/utils.ts — duplicated here so
 * @xeito/ui is self-contained (no upstream apps/web dependency).
 */
export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}
